import admin from '@Apis/admin.api';

export const getSubscriptions = () => admin.get('/subscriptions-usage');
